module.exports = __webpack_public_path__ + "img/Gallery_3_12.c0876c83.jpeg";